import { Reveal } from "@components/ui";

const inspectionItems = [
  "Full leak check",
  "Pressure testing",
  "Regulator calibration",
  "Valve & hose inspection",
  "Combustion check for appliances",
  "Civil Defense compliance checklist",
  "Issuance of safety report (digital PDF)",
];

export function AnnualInspectionSection() {
  return (
    <section className="w-full bg-[#f5f5f7] overflow-hidden px-5 md:px-10 lg:px-[180px] pt-4 md:pt-6 lg:pt-8 pb-12 md:pb-16 lg:pb-[100px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col lg:flex-row items-start gap-10 md:gap-14 lg:gap-20">
        {/* Left Content */}
        <Reveal direction="left" className="w-full lg:flex-1">
          <div className="flex flex-col items-start gap-6 md:gap-8">
            <div className="flex flex-col gap-3">
              <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.02em] uppercase w-fit">
                Annual Program
              </span>
              <h2 className="text-[28px] md:text-[44px] lg:text-[54px] font-semibold tracking-[-0.04em] text-[#122d63] leading-[1.1]">
                GASIS Annual Safety Inspection
              </h2>
            </div>
            <p className="text-[14px] md:text-[18px] lg:text-[22px] tracking-[-0.03em] text-[#62636c] leading-[1.5]">
              Every connected unit receives a certified inspection that includes
              comprehensive safety checks performed by DCD-certified
              technicians.
            </p>

            {/* Alert Box */}
            <div className="w-full rounded-[14px] bg-gradient-to-r from-[#fff5f3] to-[#fff0ec] border border-[#f24d2b]/30 px-5 md:px-6 py-4 md:py-5 flex items-center gap-3">
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#f24d2b]/15 flex items-center justify-center shrink-0">
                <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5">
                  <path d="M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10z" stroke="#f24d2b" strokeWidth="1.5" />
                  <path d="M12 8v4M12 16h.01" stroke="#f24d2b" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </div>
              <p className="text-[13px] md:text-[16px] lg:text-[18px] tracking-[-0.03em] text-[#1e1f24] leading-[1.5]">
                Customers are notified at least{" "}
                <strong className="text-[#f24d2b]">24 hours in advance</strong>{" "}
                for scheduled inspections.
              </p>
            </div>
          </div>
        </Reveal>

        {/* Right Content - Numbered List */}
        <Reveal direction="right" className="w-full lg:w-[540px] shrink-0">
          <div className="flex flex-col gap-3 md:gap-3.5">
            {inspectionItems.map((item, index) => (
              <div
                key={index}
                className="group flex items-center gap-4 md:gap-5 p-4 md:p-5 rounded-[16px] bg-white hover:shadow-[0_4px_20px_rgba(0,0,0,0.07)] transition-all duration-300 border border-transparent hover:border-[#e8e9ed]"
              >
                {/* Number Badge */}
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-[12px] bg-[#1e1f24] group-hover:bg-[#122d63] flex items-center justify-center shrink-0 transition-colors duration-300">
                  <span className="text-[13px] md:text-[15px] font-bold text-white">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
                {/* Text */}
                <p className="text-[15px] md:text-[18px] lg:text-[20px] tracking-[-0.03em] text-[#1e1f24] font-medium">
                  {item}
                </p>
                {/* Subtle arrow on hover */}
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  className="w-5 h-5 ml-auto shrink-0 opacity-0 group-hover:opacity-50 transition-opacity"
                >
                  <path d="M9 18l6-6-6-6" stroke="#62636c" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
